/**
 * Chat IA, Enigma and Dashboard are hidden for the AppSource launch.
 * Flip to true to bring back their routes, sidebar buttons and sheet cleanup.
 * Before re-enabling Enigma/Dashboard, tag their sheets with OWNED_SHEET_KEY
 * like projects do: their cleanup still deletes by name ("Datos", "Resumen"…).
 */
export const EXTRA_TOOLS_ENABLED = false;
